module.exports = __webpack_public_path__ + "img/ydwtgl.1f4b6d50.png";